








































import $store from "@/store/store";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class DttConfig extends Vue {
  public showMe: boolean = true;
  @Prop() public descriptions: any;
  public config: any = {
    merim_referential: "BKF",
    merim_report: "DTT_DAILY",
    merim_daysofweek: new Array(),
    merim_dayparts: new Array(),
  };

  public descriptionsSimple() {
    const newArray = new Array();
    for (const prop of this.descriptions) {
      if (
        prop.name.includes("daybefore") ||
        prop.name.includes("business") ||
        prop.name.includes("restauids") ||
        prop.name.includes("merim_title") ||
        prop.name.includes("merim_format")
      ) {
        // DO NOTHING
      } else {
        newArray.push(prop);
        /* if (prop.clazz.includes("Set")) {
          this.config.set(prop.name, new Array());
        } else if (prop.defaut !== "") {
          this.config.set(prop.name, prop.defaut.toUpperCase());
        } else if (prop.name.includes("report")) {
            this.config.set("merim_report", "DTT_DAILY");
        } else {
          this.config.set(prop.name, "");
        } */
      }
    }
    return newArray;
  }

  public selectValue(value: any, prop: any) {
    if (prop.clazz.includes("Set")) {
      if (this.config[prop.name].indexOf(value) !== -1) {
        this.config[prop.name].splice(this.config[prop.name].indexOf(value), 1);
      } else {
        this.config[prop.name].push(value);
      }
    } else {
      this.$set(this.config, prop.name, value);
    }
  }

  public isDisable(prop: any): boolean {
    if (prop.name.includes("merim_report")) {
      return false;
    } else {
      const rep = this.config.merim_report;
      if (prop.reports.indexOf(rep) !== -1) {
        return false;
      }
      return true;
    }
  }

  public isActive(value: any, prop: any) {
    if (prop.clazz.includes("Set")) {
      const arr: string[] = this.config[prop.name];
      if (arr.indexOf(value) !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return this.config[prop.name] === value;
    }
  }

  public hideDtt() {
    this.$emit("validate", this.config);
  }
}
